module.exports = __webpack_public_path__ + "3b270d21dfaf13d2fdfdf5e9ebdcf075.png";